import script from "./DocumentReader.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentReader.vue?vue&type=script&setup=true&lang=js"

import "./DocumentReader.vue?vue&type=style&index=0&id=71d874f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d874f7"]])

export default __exports__